export default {
  init() {
    window.onload = () => {
      setTimeout(() => {
        location.reload();
      }, 60000);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pedidos.js